var file_upload_viewer_default = {
  "fontElementMap": "UVdzu",
  "file_upload_container": "QRFyX",
  "file_upload_link": "ae2Zr",
  "file_upload_error_container": "Bsfkg",
  "file_upload_file_info": "kzGRh",
  "file_upload_type_icon": "_-4vlb",
  "file_upload_status_icon_container": "h6I3j",
  "file_upload_status_icon": "fMFs6",
  "file_upload_description": "Sy4rA",
  "file_upload_name_container": "E--5s",
  "file_upload_name": "CDRsP",
  "file_upload_extension": "yYv-E",
  "file_loader_icon": "WaQwu",
  "file_upload_icon_frame": "Z4G2L",
  "file_upload_icon_background": "_9XALf"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
